function renderAttributes(element, attrMap) {
    for (const a in attrMap) {
        const v = attrMap[a] === true ? '' : attrMap[a];
        if (v || v === '' || v === 0) {
            if (element.getAttribute(a) !== v) {
                element.setAttribute(a, v.toString());
            }
        } else if (element.hasAttribute(a)) {
            element.removeAttribute(a);
        }
    }
}
function queryParentRoots($elem, query) {
    if ($elem.shadowRoot == null) {
        return [];
    }
    const $root = $elem.shadowRoot.host.getRootNode();
    const matches = $root.querySelectorAll(query);
    if (matches.length > 0) {
        return Array.from(matches);
    }
    return queryParentRoots($root, query);
}
function traverseActiveElements(activeElement = document.activeElement) {
    if (activeElement != null && activeElement.shadowRoot != null && activeElement.shadowRoot.activeElement != null) {
        return traverseActiveElements(activeElement.shadowRoot.activeElement);
    }
    return activeElement;
}
function getSlottedElements(root) {
    return Array.from(root.querySelector('slot').assignedNodes()).filter(node => node.nodeName !== `#text`);
}
function removeChildren($container) {
    while ($container.firstChild) {
        $container.firstChild.remove();
    }
}
function sanitize(html) {
    return html.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#039;').replace(/"/g, '&quot;');
}
function isHidden($elem, style) {
    if (style != null) {
        return style.display === 'none';
    }
    return $elem.offsetParent === null;
}
function setProperty(name, value, $target = document.documentElement) {
    $target.style.setProperty(name, value);
}
function removeProperty(name, $target = document.documentElement) {
    $target.style.removeProperty(name);
}

export { getSlottedElements, isHidden, queryParentRoots, removeChildren, removeProperty, renderAttributes, sanitize, setProperty, traverseActiveElements };
